// extracted by mini-css-extract-plugin
export default {"alNum":"LockTimer_alNum__t3QpW"};